import React, { Component } from 'react'
import Modal from 'react-modal'
import { withRouter } from 'react-router-dom'
import CacheKeys from '../../../cache/CacheKeys'
import CacheManager from '../../../cache/CacheManager'
import RestApiUtils from '../../../apiclient/moebli/RestApiUtils'
import AccountDescUpdateModalUI from './AccountDescUpdateModalUI.js'

class AccountDescUpdateModalSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      successMsg: null,
      errorList: null,
      // form events
      submitted: false,
      // form field
      accountName:'',
      businessName: this.props.account.businessName || '',
      accountDesc: this.props.account.accountDesc || '',
      descError: null,
    }
  }

  render() {
    return (
      <AccountDescUpdateModalUI
        context={this.props.context}
        errorList={this.state.errorList}
        successMsg={this.state.successMsg}
        setErrorList={this.setErrorList}
        // modes
        updateMode={this.props.updateMode}
        submitted={this.state.submitted}
        // event handlers
        onSubmit={this.onSubmit}
        onCancelClick={this.props.onCancelClick}
        // form fields
        accountName={this.state.accountName}
        onAccountNameChange={(event) => {this.setState({ accountName: event.target.value })}}
        accountNameError={this.state.accountNameError}
        setAccountNameError={(error) => {this.setState({ accountNameError: error })}}

        //
        businessName={this.state.businessName}
        onBusinessNameChange={(event) => { this.setState({ businessName: event.target.value }) }}
        businessNameError={this.state.businessNameError}
        setBusinessNameError={(error) => { this.setState({ businessNameError: error }) }}
        //
        accountDesc={this.state.accountDesc}
        onAccountDescChange={(event) => { this.setState({ accountDesc: event.target.value }) }}
        descError={this.state.descError}
        setDescError={(error) => { this.setState({ descError: error }) }}
      />
    )
  }

  componentDidMount() {
    let context = this.props.context
    Modal.setAppElement('body')
  }

  onSubmit = () => {
    let submitted = this.state.submitted
    if (submitted)
      return

    this.setState({
      successMsg: null,
      errorList: [],
      submitted: true
    })

    let context = this.props.context
    RestApiUtils.put(this.props.context,
      `/api/su/accounts/${this.props.account.accountId}/description`,
      this.onSubmitCallback,
      {
        accountName: this.state.accountName,
        businessName: this.state.businessName,
        accountDesc: this.state.accountDesc,
      }
    )
  }

  onSubmitCallback = (response) => {
    let errorList = []
    response.errorList.forEach(error => {
      errorList.push(error.message)
    })

    this.setState({
      successMsg: response.success,
      errorList: errorList,
      submitted: false
    })

    if (response.errorList.length === 0) {
      setTimeout(() => {
        this.setState({
          successMsg: null
        })
        this.props.onCancelClick()
        this.props.onRefreshClick('noBusy')
      }, 2000)
    }
  }

  setErrorList = (errorList) => {
    this.setState({ errorList: errorList })
  }
}

export default AccountDescUpdateModalSF
